import { SvgIcon } from "@mui/material"

import { ReactComponent as StreetView } from "./Street_view_icon.svg"

export const StreetViewIcon = (props) => {
    return (
        <SvgIcon component={StreetView} {...props} inheritViewBox />
    )
}